import React from "react";
import AppRouter from "./Components/Router/Router.jsx";
// import Navbar from "./Components/Navbar/Navbar.jsx";
import Footer from "./Components/Footer/Footer.jsx";
import Navbar1 from "./Components/Navbar1/Navbar1.jsx";
import './App.css'
import LanguageSwitcher from "./Langswitch/Langswitch.jsx";

const App = () => {
  return (

    <>
    <div className="navbaraa">
      <Navbar1/>
      <LanguageSwitcher/>
      {/* <Navbar/> */}
    </div>

    <div className="approuter">
    <AppRouter/>
    </div>

    <div>
     <Footer/>
    </div>
    </>
  )
}

      
     

export default App;
